<!-- 批量签收 -->
<template>
	<div>
		<el-row>
			<el-col :span="12" :offset="6">
				<span style="color: red;"> 如扫码无反应，请确认鼠标焦点是否在该页面上!!!</span>
				<el-form :inline="true">
					<el-form-item label="运单号">
						<el-input ref='tn' placeholder="扫码或填写" v-model="scan_tn" clearable> </el-input>
					</el-form-item>
					<el-button type="primary" @click="getOrder">搜索</el-button>
					<span style="margin-left: 15px;">总单数：{{create_data.length}}</span>
					<span style="margin-left: 15px;">总实际金额：{{true_money_total}}</span>
				</el-form>
			</el-col>
		</el-row>
		<el-row>
			<el-col v-if="create_data.length > 0">
			<!-- <el-col> -->
				<el-tooltip class="item" effect="dark" content="请把订单都导入后再批量上传图片.图片太多上传会比较慢,请耐心等待." placement="top">
					<signImgBatch style="display: inline-block;margin-left: 49%;" @imgList="imgsImgBatch"
						:img_edit="[]"></signImgBatch>
				</el-tooltip>
				<el-input style="width: 120px;margin-left: 5%;" v-model="sign_remarks_init" placeholder="请输入内容">
				</el-input>
				<el-button type="primary" @click="signOne">一键备注</el-button>
			</el-col>
			<el-table :data="create_data" stripe style="width: 100%">
				<el-table-column prop="order_number" label="订单号"></el-table-column>
				<el-table-column prop="price" label="订单金额">
					<template slot-scope="{row,$index}">
						<span>{{row.price}} - {{row.coin_name}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="sign_price" label="实际金额">
					<template slot-scope="{row,$index}">
						<el-input-number :precision="2" :step="0.1" v-model="row.sign_price"></el-input-number>
						<span>{{row.coin_name}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="tn_number" label="运单号"></el-table-column>
				<el-table-column prop="date" label="截图" :width="xiang_size == 1 ? 420 : ''">
					<template slot-scope="{row,$index}">
						<signImg @imgList="imgsImg($event,$index)" :img_num="1" :img_edit="row.sign_img" :xiang_size="xiang_size"></signImg>
					</template>
				</el-table-column>
				<el-table-column prop="date" label="签收备注">
					<template slot-scope="{row,$index}">
						<el-input v-model="row.sign_remarks" placeholder="请输入内容"></el-input>
					</template>
				</el-table-column>
				<el-table-column prop="msg" label="信息">
					<template slot-scope="{row,$index}">
						<span v-if="row.msg == '成功'" style="color: green;">{{row.msg}}</span>
						<span v-if="row.msg != '成功'" style="color: red;">{{row.msg}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="" label="操作">
					<template slot-scope="{row,$index}">
						<el-popconfirm @confirm="orderDel($index,row.id)" @onConfirm="orderDel($index,row.id)" title="确定删除？">
							<el-button style="margin-left:10px;" type="danger" size="mini" slot="reference">删除
							</el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
		</el-row>
		<el-button v-if="create_data.length > 0" :loading="this.$store.state.ajaxLoading"
			style="margin-top: 15px;margin-left: 46%;" type="success" @click="signUpBatch">提交</el-button>
	</div>
</template>

<script>
	import {
		getOrder,
		signUpBatch
	} from '@/api/sign_admin'
	import {
		alertMsg
	} from '@/tool/index';
	import Qs from 'qs'
	import signImg from '@/components/Jd/signImg.vue' // 上传图片组件
	import signImgBatch from '@/components/Jd/signImgBatch.vue' // 批量上传图片组件并保证图片顺序
	export default {
		name: 'signBatch',
		components: {
			signImg,
			signImgBatch
		},
		data() {
			return {
				scan_tn: '',
				create_data: [],
				id_arr: [], // 已经存在的id
				sign_remarks_init: '',
				xiang_size:0,
			}
		},
		computed: {
			// 实际总金额
			true_money_total() {
				let money = 0;
				this.create_data.forEach((item) => {
					money = money + parseFloat(item.sign_price);
				});
				return money.toFixed(2);
			}
		},
		// 定义组件的属性
		props: {
			is_show_sign_batch: {
				type: Boolean,
				default: false,
			},
			admin_id:{
				type: Number,
				default: 0,
			}
		},
		watch: {
			is_show_sign_batch() {
				this.resetCreateData();
				// 因为真实节点还没生成，所以必须使用this.$nextTick
				this.$nextTick(() => {
					this.$refs.tn.focus();
				})
			},
		},
		created() {
			this.resetCreateData();
			// 因为真实节点还没生成，所以必须使用this.$nextTick
			this.$nextTick(() => {
				this.$refs.tn.focus();
			})
			this.codeListen();
		},
		methods: {
			// 重置create_data数据
			resetCreateData() {
				this.scan_tn = '';
				this.create_data = [];
				this.id_arr = [];
				this.sign_remarks_init = '';
			},
			// 获取到订单
			getOrder() {
				// 隐藏功能，图片变大
				if(this.scan_tn == '大'){
					this.xiang_size = 1;
					this.scan_tn = '';
					if(this.admin_id == 1 || this.admin_id == 9){
						alertMsg(this, '恭喜触发隐藏要素，你变得跟坤哥一样大了 (✪ω✪)', 'success');
					}
					return false;
				}else if(this.scan_tn == '小'){
					this.xiang_size = 0;
					this.scan_tn = '';
					if(this.admin_id == 1 || this.admin_id == 9){
						alertMsg(this, '恭喜触发隐藏要素，你变得跟坤哥还小 (✪ω✪)',);
					}
					return false;
				}
				
				// kerry会有空格加其他字符串，所以这里要裁剪
				if(this.scan_tn.indexOf(' ') != -1){
					let arr = this.scan_tn.split(" ");
					this.scan_tn = arr[0];
				}
				let post = {
					tn: this.scan_tn
				};
				
				getOrder(Qs.stringify(post)).then(response => {
					let r = response.result;
					if (this.id_arr.indexOf(r.id) != -1) {
						return alertMsg(this, '该订单已存在');
					}
					this.scan_tn = '';
					this.create_data.unshift(r);
					this.id_arr.push(r.id);
					alertMsg(this, '订单信息获取成功', 'success');
					this.$refs.tn.focus();
				})
			},
			// 上传图片回调
			imgsImg(e, index,type='') {
				this.create_data[index].sign_img = e[0].url;
			},
			// 删除列表数据
			orderDel(index,id) {
				this.create_data.splice(index, 1);
				
				let id_index = this.id_arr.indexOf(id);
				if(id_index != -1){
					this.id_arr.splice(id_index, 1);
				}
				console.log(this.id_arr)
			},
			// 提交
			signUpBatch() {
				this.$store.commit('setAjaxLoading', true);
				let post = {
					data: JSON.stringify(this.create_data)
				}
				signUpBatch(Qs.stringify(post)).then(response => {
					let r = response.result;
					this.create_data.forEach((item, index) => {
						r.forEach((item2, index2) => {
							if (item.id == item2.id) {
								this.create_data[index].msg = item2.msg;
							}
						});
					});

					// 把已成功的删除掉
					let new_data = [];
					this.create_data.forEach((item, index) => {
						if (item.msg != '成功') {
							new_data.push(item);
						}
					});
					this.create_data = new_data;

					alertMsg(this, '共处理' + r.length + '条订单', 'success');
				})
			},
			// 一键备注
			signOne() {
				this.create_data.forEach((item, index) => {
					this.create_data[index].sign_remarks = this.sign_remarks_init;
				});
				alertMsg(this, '已一键备注', 'success');
			},
			// 接收批量上传的图片
			imgsImgBatch(e) {
				if(this.create_data.length != e.length){
					return alertMsg(this, '上传的图片数和订单数不一致');
				}
				this.create_data.forEach((item, index) => {
					this.create_data[index].sign_img = [{
						name:index,
						url:e[index]
					}];
				});
				return alertMsg(this, '图片批量上传完成','success');
			},
			// 监听扫码
			codeListen() {
				let code = "";
				let lastTime, nextTime;
				let lastCode, nextCode;
				document.onkeypress = (e) => {
					if (window.event) { // IE
						nextCode = e.keyCode;
					} else if (e.which) { // Netscape/Firefox/Opera
						nextCode = e.which;
					}
					if (nextCode === 13) {
						e.preventDefault(); // 禁用所有的回车
						if (code.length < 3) return; // 手动输入的时间不会让code的长度大于2，所以这里只会对扫码枪有

						// 获取订单详情
						this.getOrder();

						code = '';
						lastCode = '';
						lastTime = '';
						return;
					}
					nextTime = new Date().getTime();
					if (!lastTime && !lastCode) {
						code += e.key;
					}

					if (lastCode && lastTime && nextTime - lastTime > 30) { // 当扫码前有keypress事件时,防止首字缺失
						code = e.key;
					} else if (lastCode && lastTime) {
						code += e.key;
					}
					lastCode = nextCode;
					lastTime = nextTime;
				}
			},
		}
	}
</script>

<style>
	.el-col-12 {
		text-align: left;
	}
</style>
